import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from '@/components/common/PageHeader';
import { useNotify } from '@/hooks/useNotify';

import { ProfesionalForm } from '../components/ProfesionalForm';
import { useCreateProfesional } from '../hooks/useProfesionales';
import type { ProfesionalFormValues } from '../schemas';
import type { ProfesionalCreate } from '../types';

export function NuevoProfesionalPage(): JSX.Element {
  const navigate = useNavigate();
  const notify = useNotify();
  const createMutation = useCreateProfesional();

  async function handleSubmit(values: ProfesionalFormValues): Promise<void> {
    const payload: ProfesionalCreate = {
      nombre_apellido: values.nombre_apellido.trim(),
      tipo_profesional: values.tipo_profesional,
      tipo_profesional_otro: values.tipo_profesional_otro?.trim() || null,
      telefono_whatsapp: values.telefono_whatsapp?.trim() || null,
      emails: values.emails,
      localidad: values.localidad?.trim() || null,
      envio_informe: values.envio_informe,
    };

    try {
      const created = await createMutation.mutateAsync(payload);
      notify.success(`Profesional "${created.nombre_apellido}" creado.`);
      navigate('/profesionales');
    } catch {
      // error displayed inside the form via the `error` prop
    }
  }

  return (
    <>
      <PageHeader
        title="Nuevo profesional"
        subtitle="Cargá los datos del profesional."
        action={
          <Button
            variant="text"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/profesionales')}
          >
            Volver
          </Button>
        }
      />

      <Card>
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <ProfesionalForm
            onSubmit={handleSubmit}
            onCancel={() => navigate('/profesionales')}
            submitLabel="Crear profesional"
            submitting={createMutation.isPending}
            error={createMutation.error}
          />
        </CardContent>
      </Card>
    </>
  );
}
